import { Language } from '@api/models';
import { NO_PREFIX_ROUTE_LANG } from '../constants';

export function getLangFromRouteLang(routeLang: string): Language {
  switch (routeLang) {
    case 'ua':
      return Language.UK;
    // case 'en':
    //   return Language.EN;
    default:
      return NO_PREFIX_ROUTE_LANG;
  }
}
